import { render } from "./UsersContent.vue?vue&type=template&id=9c20b526&ts=true"
import script from "./UsersContent.vue?vue&type=script&lang=ts"
export * from "./UsersContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__